import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointVerticalComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalComponent';
import KeyPointVerticalMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalMobileComponent';
import keyPointVerticalData from '../../json/components/HomePages/LifeInsurance/keyPointVerticalData.json';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/LifeInsurance/keyPointVerticalNumericData.json';

import SeoSnakeGuideComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideComponent';
import SeoSnakeGuideMobileComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideMobileComponent';
import snakeGuideData from '../../json/components/HomePages/LifeInsurance/snakeGuideData.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsMobileComponent';
import sectionStepsData from '../../json/components/HomePages/LifeInsurance/sectionStepsData.json';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/LifeInsurance/partnerBrandsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/LifeInsurance/fourBlogCardsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/LifeInsurance/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/LifeInsurance/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/LifeInsurance/scrollingCardsData.json';
import scrollingCardsData2 from '../../json/components/HomePages/LifeInsurance/scrollingCardsData2.json';
import scrollingCardsDataAll from '../../json/components/HomePages/LifeInsurance/scrollingCardsAllData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function LifeInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/life-insurance-quote/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestLifeInsuranceQuotes_CrossSell"
        fallbackKey="latestLifeInsuranceQuotes"
        navigateTo="/life-insurance-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoArmsCrossed'}
            title={'Life changed. Has your life cover kept up?'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoArmsCrossed'}
            title={'Life changed. Has your life cover kept up?'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoSnakeGuideComponent data={snakeGuideData} />
        ) : (
          <SeoSnakeGuideMobileComponent data={snakeGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsComponent data={sectionStepsData} />
        ) : (
          <SectionStepsMobileComponent data={sectionStepsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandSideTiltFace'}
            imageDirection="right"
            title={'Dunno if your family’s still covered?'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandSideTiltFace'}
            title={'Dunno if your family’s still covered?'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalComponent data={keyPointVerticalData} />
        ) : (
          <KeyPointVerticalMobileComponent data={keyPointVerticalData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData2} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData2} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="life-insurance"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="life-insurance"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'The easiest way to compare life cover'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'The easiest way to compare life cover'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataAll} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataAll} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default LifeInsurancePage;
